/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { Chain } from '@shared/data-access/interfaces';
import { HOME_CONSTANTS } from '../../app.constants';
import { ISectionHeader } from './section-header.interface';
import { UtilityService } from '@shared/utils/services';

@Component({
    selector: 'home-section-header',
    templateUrl: './section-header.component.html',
    styleUrls: ['./section-header.component.scss'],
    standalone: false
})
export class SectionHeaderComponent implements OnInit {
	public chainAbbr: string;
	public isGGStaticPage: boolean;
	public marginTop: any;
	public ggStaticColors = HOME_CONSTANTS.ggStaticColors;

	@Input() data: ISectionHeader[];
	@Input() addlData: any;
	@Input() tagSectionNum: string;
	@Input() widgetTypeTag: string;
	@Input() staticPage: boolean;

	constructor(
		private chain: Chain,
		private utilityService: UtilityService
	) {
		this.chainAbbr = this.chain.chainIdentifierAbbr;
	}

	ngOnInit() {
		this.isGGStaticPage = this.utilityService.ggStaticPage(this.addlData.isStaticPage);
		this.marginTop = this.returnMarginTop();
	}

	returnColor(useBackdrop: any, textColor: string) {
		if (!useBackdrop) {
			return '';
		}

		if (useBackdrop) {
			return 'backdrop ' + `${textColor}-text`;
		}
	}

	returnMarginTop() {
		if (!this.data) {
			return '';
		}
		if (this.data && this.data[0].marginTop) {
			if (this.data[0].marginTop === 'TRUE') {
				return `${'hmf-mt-xxl'}`;
			} else {
				return '';
			}
		}
	}

	filterMore(heading) {
		return heading.replace(/\?|/g, '');
	}
}
